import { render, staticRenderFns } from "./Brannvakt.vue?vue&type=template&id=6ae03430&scoped=true&"
import script from "./Brannvakt.vue?vue&type=script&lang=js&"
export * from "./Brannvakt.vue?vue&type=script&lang=js&"
import style0 from "./Brannvakt.vue?vue&type=style&index=0&id=6ae03430&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ae03430",
  null
  
)

export default component.exports